import type { Schemas } from "~/types/generated";

export type AuthCtaMode = "sign-up" | "sign-in";

export enum AuthNotice {
  AlreadySignedIn = "auth-already-signed-in",
  NewAccountsOnly = "auth-new-accounts-only",
}

export enum SignUpCampaign {
  Lifetime = "lifetime",
}

export interface ISignUpCampaignMetadata extends SignUpUnsafeMetadata {
  signupCampaign: string;
}

export type ISignUpRequestBody = Schemas["SubmitEmailDto"];

export type GetUpdatesSource = ISignUpRequestBody["source"];

export interface ISignUpResponseBody {
  success: boolean;
  message: string;
}
